import React, {useEffect, useState} from 'react';
import {useDispatch, useSelector} from "react-redux";

import { Modal, Button, Input, Spin} from "antd";

import { startSigningProcess,clearSigningStatus} from '../../store/electronic-signature/actions';

import {routePath} from "../../router/paths";
import { SyncOutlined} from "@ant-design/icons";

const SignatureModal=(props)=> {
  const dispatch = useDispatch();
  const [kepId, setKepId] = useState(null);
  const [touched, setTouched] = useState(false);
  const signing = useSelector((state) => state.signing);
  const user = useSelector((state) => state.user);

  const newRequestInfo =  useSelector((state) => state.newRequest);

  useEffect(()=>{
    if( user && user.data && user.data.kepId ){
      console.log("inside", user && user.data && user.data.kepId)
      setKepId(user.data.kepId);
    }
    return () => {
      dispatch(clearSigningStatus());
    }
  }, []);

  useEffect(() => {
      if (signing && signing.payload && signing.payload.data && signing.payload.data.result === true) {
        props.hideUploadModal();
        props.history.push({
          pathname: routePath.REQUEST_LIST,
          state: {backPath: props.history.location.pathname}
        });
      }
    },
    [props.history, signing]);

  const handleKepChange = e =>{
    const {value} = e.currentTarget;
    setKepId(value);
    setTouched(true);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log("newRequestInfo.payload", newRequestInfo.payload )
    const id = newRequestInfo && newRequestInfo.payload && newRequestInfo.payload.data
    dispatch(startSigningProcess(id ,kepId));
  }

  const Loading = <SyncOutlined style={{ fontSize: 24 }} spin />;

  return (
    <Modal
      className="signing_modal"
      title="Підписання запиту"
      closable={false}
      maskClosable={false}
      visible={props.visible}
      onCancel={props.hideUploadModal}
      footer={[
        <Button key="back" onClick={props.hideUploadModal}>Повернутися</Button>
      ]}
    >
      <div className="container">
        <form>
          <>
            <div className="kep-label">Ідентифікатор користувача при підключенні до Диспетчера КЕП:</div>
            {console.log("kepId",kepId)}
            {
              kepId && !touched?
              <>
                {!touched &&
                <div>Введено ідентифкатор, під яким ви увішли в систему, для його зміни скопіюйте інший
                  ідентифікатор з менеджеру ЕЦП</div>}
                <Input
                  type="text"
                  allowClear
                  defaultValue={user && user.data && user.data.idm && user.data.idm.kepId}
                  placeholder='Введіть ідентифікатор користувача'
                  name="identity"
                  onChange={handleKepChange}
                />
              </>
              :
            <Input
              type="text"
              allowClear
              placeholder='Введіть ідентифікатор користувача'
              name="identity"
              onChange={handleKepChange}
            />
            }

            <div className="button_center">
              <Button
                style={{color: "#000000", marginTop:"8px", marginBottom:"8px"}}
                disabled={!kepId || signing.isFetching}
                onClick={handleSubmit}
                key="submit"
                type="primary"
              >Розпочати процесс підписання</Button>
            </div>
          </>
          {/*{*/}
          {/*  <div style={{display: "flex", flexDirection: "row",}}>*/}
          {/*    <ExclamationCircleOutlined style={{*/}
          {/*      fontSize: 24,*/}
          {/*      color: "#fc5a61",*/}
          {/*      borderRadius: "2px",*/}
          {/*      marginLeft: "4px",*/}
          {/*      marginRight:"5px",*/}
          {/*      marginTop:"8px"*/}
          {/*    }}/>*/}
          {/*    /!*<p style={{marginTop:"8px", fontSize: "14px"}}>Ahtung</p>*!/*/}
          {/*  </div>*/}
          {/*}*/}
          {signing && signing.isFetching &&
          <div style={{fontSize: "16px" }}>
            Відбувається процес підписання <Spin style={{marginLeft: "4px"}} indicator={Loading} />
          </div>}
        </form>
      </div>
    </Modal>
  );
}

export default SignatureModal;

